import React from 'react';
export const ICON_TYPES = {
  TIMER: 'timer',
  BELL: 'bell',
  CHECK: 'check',
  UPDATE: 'update',
  CANCEL: 'cancel',
  ALERT: 'alert',
} as const;

export type IconType = (typeof ICON_TYPES)[keyof typeof ICON_TYPES];

type IconProps = {
  color?: string;
};

export const IconAssets: Record<IconType, React.FC<IconProps>> = {
  [ICON_TYPES.TIMER]: ({ color = '#000' }: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
        fill={color}
      />
    </svg>
  ),
  [ICON_TYPES.BELL]: ({ color = '#000' }: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3V5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5C8.69 5 6 7.69 6 11V17C5 17 4 18 4 19H12M12 5C15.31 5 18 7.69 18 11V17C19 17 20 18 20 19H12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  [ICON_TYPES.CHECK]: ({ color = '#000' }: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35327_18162)">
        <path
          d="M3 12L10 18L22 6"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35327_18162">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  [ICON_TYPES.UPDATE]: ({ color = '#000' }: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35345_16255)">
        <path
          d="M15.1523 7.96265L15.1104 8.46167C14.8021 12.1446 11.7214 15.0328 7.96582 15.033C5.23142 15.0328 2.85379 13.494 1.64648 11.24L1.36133 13.2566L0.866211 13.1863L0.371094 13.1169L0.837891 9.81616L0.908203 9.32104L1.40332 9.39136L1.96094 9.46948L1.98828 9.46069L1.99316 9.47437L4.70312 9.85815L5.19824 9.92847L5.05762 10.9187L4.56348 10.8484L2.41309 10.5437C3.41164 12.607 5.52582 14.0328 7.96582 14.033C11.1965 14.0328 13.8491 11.5477 14.1143 8.37769L14.1553 7.87964L15.1523 7.96265ZM1.36133 13.2566L1.29102 13.7517L0.300781 13.6111L0.371094 13.1169L1.36133 13.2566ZM7.96582 0.699951C10.7207 0.699974 13.1154 2.26131 14.3135 4.54175L14.6045 2.48999L14.6748 1.99487L15.665 2.1355L15.5947 2.63062L15.1279 5.93042L15.0596 6.42456L15.0576 6.42358V6.42554L14.4258 6.33569L13.9785 6.27319L13.9473 6.28491L13.9414 6.26831L11.2637 5.89526L10.7686 5.82593L10.9072 4.83569L11.4023 4.90503L13.5254 5.20093C12.5309 3.13237 10.4122 1.69997 7.96582 1.69995C4.729 1.70004 2.07657 4.19072 1.81738 7.36694L1.77734 7.86597L0.780273 7.78394L0.821289 7.28589L0.857422 6.94214C1.31543 3.41751 4.3206 0.700042 7.96582 0.699951Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_35345_16255">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  [ICON_TYPES.CANCEL]: ({ color = '#000' }: IconProps) => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.81152 2.44897L12.6201 9.37866L19.5508 2.57007L20.6201 1.51929L22.7227 3.65894L21.6523 4.71069L14.7227 11.5183L21.5312 18.449L22.582 19.5183L20.4424 21.6208L19.3916 20.5505L12.583 13.6208L5.65234 20.4304L4.58301 21.4812L2.48047 19.3416L3.55078 18.2908L10.4805 11.4812L3.6709 4.55054L2.62012 3.4812L4.75977 1.37866L5.81152 2.44897Z"
        fill={color}
      />
    </svg>
  ),
  [ICON_TYPES.ALERT]: ({ color = '#000' }: IconProps) => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35327_18186)">
        <g clipPath="url(#clip1_35327_18186)">
          <path
            d="M10.1869 1.57038C11.1754 -0.280621 13.8274 -0.280621 14.8159 1.57038L23.9389 18.6374C24.1527 19.0373 24.2592 19.4858 24.2481 19.9391C24.237 20.3924 24.1087 20.8352 23.8756 21.2241C23.6425 21.6131 23.3126 21.9351 22.9181 22.1587C22.5236 22.3822 22.0779 22.4998 21.6244 22.4999H3.37841C2.92494 22.4998 2.47923 22.3822 2.0847 22.1587C1.69018 21.9351 1.3603 21.6131 1.12722 21.2241C0.894131 20.8352 0.765787 20.3924 0.754692 19.9391C0.743597 19.4858 0.85013 19.0373 1.06391 18.6374L10.1869 1.57038ZM12.8314 2.63088C12.7993 2.57135 12.7516 2.52162 12.6935 2.48696C12.6354 2.45229 12.5691 2.43399 12.5014 2.43399C12.4338 2.43399 12.3674 2.45229 12.3093 2.48696C12.2512 2.52162 12.2035 2.57135 12.1714 2.63088L3.04841 19.6979C3.01784 19.755 3.00258 19.819 3.00411 19.8837C3.00564 19.9485 3.02391 20.0117 3.05714 20.0673C3.09037 20.1229 3.13742 20.1689 3.19372 20.2009C3.25002 20.2329 3.31365 20.2498 3.37841 20.2499H21.6244C21.6892 20.2498 21.7528 20.2329 21.8091 20.2009C21.8654 20.1689 21.9124 20.1229 21.9457 20.0673C21.9789 20.0117 21.9972 19.9485 21.9987 19.8837C22.0002 19.819 21.985 19.755 21.9544 19.6979L12.8314 2.63088ZM13.6264 8.62488V12.3749C13.6264 12.6732 13.5079 12.9594 13.2969 13.1704C13.0859 13.3814 12.7998 13.4999 12.5014 13.4999C12.203 13.4999 11.9169 13.3814 11.7059 13.1704C11.4949 12.9594 11.3764 12.6732 11.3764 12.3749V8.62488C11.3764 8.32651 11.4949 8.04036 11.7059 7.82938C11.9169 7.61841 12.203 7.49988 12.5014 7.49988C12.7998 7.49988 13.0859 7.61841 13.2969 7.82938C13.5079 8.04036 13.6264 8.32651 13.6264 8.62488ZM14.0014 16.4999C14.0014 16.8977 13.8434 17.2792 13.5621 17.5605C13.2808 17.8418 12.8992 17.9999 12.5014 17.9999C12.1036 17.9999 11.7221 17.8418 11.4407 17.5605C11.1594 17.2792 11.0014 16.8977 11.0014 16.4999C11.0014 16.1021 11.1594 15.7205 11.4407 15.4392C11.7221 15.1579 12.1036 14.9999 12.5014 14.9999C12.8992 14.9999 13.2808 15.1579 13.5621 15.4392C13.8434 15.7205 14.0014 16.1021 14.0014 16.4999Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_35327_18186">
          <rect
            width="24"
            height="24"
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
        <clipPath id="clip1_35327_18186">
          <rect
            width="24"
            height="24"
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
};
